export const ChargeAccountStatementTableComponent: ng.IComponentOptions = {
    bindings: {
        title: '=',
        chargeAccountId: '=',
        limitMode: '='
    },
    templateUrl: 'app/angularJS/components/charge-account-statement-table/charge-account-statement-table.html',
    controller: 'ChargeAccountStatementTableController',
    controllerAs: 'vm'
};
